import React, { Component } from 'react';
import { connect } from 'react-redux';

class Login extends Component {
  render() {
    return (
      <p>Login</p>
    );
  }
}

export default connect((state, props) => {
  return {};
})(Login);



// WEBPACK FOOTER //
// ./src/scenes/Login.js